export default __webpack_public_path__ + "static/broadcast1-47c73693fbe0965fc83f5a665ba6a64f.png";